(function () {
  var el = document.getElementById('countdown-timer');
  if (!el) return;

  var campaignId = el.getAttribute('data-campaign-id');
  var dismissKey = 'countdown-dismissed-' + campaignId;
  var isDismissible = el.getAttribute('data-dismissible') === 'true';

  if (isDismissible) {
    try {
      if (sessionStorage.getItem(dismissKey)) return;
    } catch (e) {
      /* sessionStorage unavailable (private browsing, blocked storage) - fall through and show the bar */
    }
  }

  var startAttr = el.getAttribute('data-start');
  var endAttr = el.getAttribute('data-end');
  var expiredBehavior = el.getAttribute('data-expired-behavior');

  var start = startAttr ? new Date(startAttr).getTime() : null;
  var hasEnd = !!endAttr;
  var end = hasEnd ? new Date(endAttr).getTime() : null;

  var daysEl = el.querySelector('[data-cd-days]');
  var daysGroupEl = el.querySelector('[data-cd-days-group]');
  var daysSepEl = el.querySelector('[data-cd-days-sep]');
  var hoursEl = el.querySelector('[data-cd-hours]');
  var minutesEl = el.querySelector('[data-cd-minutes]');
  var secondsEl = el.querySelector('[data-cd-seconds]');
  var timerEl = el.querySelector('[data-countdown-timer]');
  var expiredMessageEl = el.querySelector('[data-countdown-expired-message]');

  var ONE_DAY_MS = 86400000;
  if (hasEnd && daysGroupEl && (end - Date.now()) >= ONE_DAY_MS) {
    daysGroupEl.hidden = false;
    if (daysSepEl) daysSepEl.hidden = false;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  var intervalId;
  var dismissed = false;

  function tick() {
    if (dismissed) {
      clearInterval(intervalId);
      return;
    }

    var now = Date.now();

    if (start && now < start) {
      el.style.display = 'none';
      return;
    }

    if (hasEnd && now >= end) {
      clearInterval(intervalId);
      if (expiredBehavior === 'show_message' && expiredMessageEl) {
        if (timerEl) timerEl.style.display = 'none';
        expiredMessageEl.hidden = false;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
      return;
    }

    el.style.display = '';

    if (!hasEnd) {
      /* announcement mode - nothing to count down, no need to keep ticking */
      clearInterval(intervalId);
      return;
    }

    var diff = end - now;
    var d = Math.floor(diff / ONE_DAY_MS);
    var h = Math.floor((diff % ONE_DAY_MS) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    if (daysEl) daysEl.textContent = d;
    if (hoursEl) hoursEl.textContent = pad(h);
    if (minutesEl) minutesEl.textContent = pad(m);
    if (secondsEl) secondsEl.textContent = pad(s);
  }

  var closeBtn = el.querySelector('[data-countdown-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      el.style.display = 'none';
      clearInterval(intervalId);
      try {
        sessionStorage.setItem(dismissKey, '1');
      } catch (e) {
        /* storage unavailable - dismissal just won't persist across pages this session */
      }
    });
  }

  var omnisendBtn = el.querySelector('[data-omnisend-form-id]');
  if (omnisendBtn) {
    omnisendBtn.addEventListener('click', function () {
      var formId = omnisendBtn.getAttribute('data-omnisend-form-id');
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', formId]);
    });
  }

  tick();
  intervalId = setInterval(tick, 1000);
})();
